import React, { Component } from "react";
import { connect } from "react-redux";
import { ActionCreators } from "../actions";

const google = window.google;
const navigator = window.navigator
let marker;
let map;
let infoWindow;

class GoogleMap extends Component {

  handleDragEnd = e => {
    this.props.getCoordinates(e.latLng.lat(), e.latLng.lng());
  };

  handleGeoLocationChange = (pos) => {
    this.props.getCoordinates(pos.lat, pos.lng);
  }

  componentDidMount() {
    map = new google.maps.Map(document.getElementById("map"), {
      zoom: 7,
      center: {
        lat: 34.7592,
        lng: -92.3871
      }
    });

    marker = new google.maps.Marker({
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: {
        lat: 34.7592,
        lng: -92.3871
      }
    });

    infoWindow = new google.maps.InfoWindow({
      content: `<h5>Drag and Drop Marker to update Coordinates </h5>`
    });


    marker.addListener("dragend", e => this.handleDragEnd(e));
    marker.addListener("click", () => infoWindow.open(map, marker))


    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        map.setCenter(pos);
        marker.setPosition(pos)
        this.handleGeoLocationChange(pos);
      }, () => {
        map.getCenter()
      });
    } else {
      // Browser doesn't support Geolocation
      map.getCenter()

    }

  }

  render() {
    return <div id="map" ref="map" />;
  }
}

export default connect(
  ({ GoogleMapsReducer }) => {
    return {
      GoogleMapsReducer
    };
  },
  ActionCreators
)(GoogleMap);



// WEBPACK FOOTER //
// ./src/components/google_maps.jsx